import { Component, OnInit } from '@angular/core';

import { LoginService } from '../../../../services/login.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { environment } from '../../../../../environments/environment'

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styles: []
})



export class SidebarComponent implements OnInit {

	CLUBNAME:string = environment.CLUBNAME;


	usuario:any = {};
	cargandoUsuario:boolean = true;

	constructor(private loginService:LoginService, private usuarioService:UsuarioService) {
	}

	ngOnInit(): void {
		this.obtenerUsuario();
	}

	/*=====================================
	=            CERRAR SESIÓN            =
	=====================================*/
	logout(){
		this.loginService.logout();
	}

	/*==============================================
	=            OBTENER USUARIO ACTUAL            =
	==============================================*/
	obtenerUsuario(){
		this.cargandoUsuario = true;
		this.usuarioService.getUsuarioActual().then( (res:any) => {
			this.usuario = res;
			this.cargandoUsuario = false;
		}).catch( (err:any) => {
			this.cargandoUsuario = false;
			console.error(err);
		});
	}

}
